import { Navigate, Route, Routes } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import AppShell from './components/layout/AppShell'
import FullPageLoader from './components/ui/FullPageLoader'
import AccessSelectorPage from './pages/AccessSelectorPage'
import DashboardPage from './pages/DashboardPage'
import LoginPage from './pages/LoginPage'
import ProtectedRoute from './routes/ProtectedRoute'
import RoleRoute from './routes/RoleRoute'
import SociosPage from './pages/SociosPage'
import NuevoSocioPage from './pages/NuevoSocioPage'
import SocioDetallePage from './pages/SocioDetallePage'
import EditarSocioPage from './pages/EditarSocioPage'
import CursosPage from './pages/CursosPage'
import NuevoCursoPage from './pages/NuevoCursoPage'
import EditarCursoPage from './pages/EditarCursoPage'
import SocioLoginPage from './pages/SocioLoginPage'
import SocioPortalPage from './pages/SocioPortalPage'
import SocioPerfilPage from './pages/SocioPerfilPage'
import SocioConsultasPage from './pages/SocioConsultasPage'
import ConsultasPage from './pages/ConsultasPage'
import AyudaPage from './pages/AyudaPage'
import ValidarSocioQrPage from './pages/ValidarSocioQrPage'
import TesoreriaPage from './pages/TesoreriaPage'
import UsuariosPage from './pages/UsuariosPage'
import PermissionRoute from './routes/PermissionRoute'
import CambiarClaveInicialPage from './pages/CambiarClaveInicialPage'
import { CAMBIO_CLAVE_PATH } from './routes/paths'

function LoginRoute() {
  const { isAuthorized, loading, debeCambiarClave } = useAuth()
  if (loading) return <FullPageLoader />
  if (!isAuthorized) return <LoginPage />
  // Con contraseña temporal se va directo al cambio obligatorio, nunca al Dashboard.
  return <Navigate to={debeCambiarClave ? CAMBIO_CLAVE_PATH : '/dashboard'} replace />
}

export default function App() {
  return (
    <Routes>
      {/* Selector público: no depende de ninguna sesión, así / nunca redirige. */}
      <Route path="/" element={<AccessSelectorPage />} />
      <Route path="/login" element={<LoginRoute />} />
      <Route path="/ayuda" element={<AyudaPage />} />
      <Route path="/socio/login" element={<SocioLoginPage />} />
      <Route path="/socio/inicio" element={<SocioPortalPage />} />
      <Route path="/socio/perfil" element={<SocioPerfilPage />} />
      <Route path="/socio/consultas" element={<SocioConsultasPage />} />
      <Route path="/validar-socio/:token" element={<ValidarSocioQrPage />} />
      <Route element={<ProtectedRoute />}>
        {/* Fuera de AppShell: sin sidebar ni navegación mientras la clave sea temporal. */}
        <Route path={CAMBIO_CLAVE_PATH} element={<CambiarClaveInicialPage />} />
        <Route element={<AppShell />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          {/* Permiso explícito (no basta el rol); el backend vuelve a validarlo. */}
          <Route element={<PermissionRoute permiso="gestionar_usuarios" />}>
            <Route path="/usuarios" element={<UsuariosPage />} />
          </Route>
          <Route element={<RoleRoute allowedRoles={['admin', 'directiva']} />}>
            <Route path="/socios" element={<SociosPage />} />
            <Route path="/socios/nuevo" element={<NuevoSocioPage />} />
            <Route path="/socios/:id" element={<SocioDetallePage />} />
            <Route path="/socios/:id/editar" element={<EditarSocioPage />} />
            <Route path="/cursos" element={<CursosPage />} />
            <Route path="/cursos/nuevo" element={<NuevoCursoPage />} />
            <Route path="/cursos/:id/editar" element={<EditarCursoPage />} />
            <Route path="/consultas" element={<ConsultasPage />} />
            <Route path="/tesoreria" element={<TesoreriaPage view="resumen" />} />
            <Route path="/tesoreria/movimientos" element={<TesoreriaPage view="movimientos" />} />
            <Route path="/tesoreria/cuentas" element={<TesoreriaPage view="cuentas" />} />
            <Route path="/tesoreria/categorias" element={<TesoreriaPage view="categorias" />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
